export const getPayment = (state) => state.payment;
export const getApplication = (state) => state.application;

export default getPayment;
